// Which full-screen shell a path belongs to. App.jsx reads these to keep the InCite ident off a shell
// that plays its own; src/Portal.jsx reads them to choose the shell. One definition, so the two
// cannot disagree about where a path lands. Exact match OR a child path: a bare startsWith would
// also claim a sibling such as /grant-foundry-archive.
export const inFoundry = (p) => p === '/grant-foundry' || p.startsWith('/grant-foundry/')
export const inTeos = (p) => p === '/eos' || p.startsWith('/eos/')
export const inRoma = (p) => p === '/roma' || p.startsWith('/roma/')
